import { isMatch } from "date-fns";

export function birthdate( value: any ){
    if(!value) return "";
    if(!isMatch(value, "yyyy-MM-dd")) return "";
    return value;
}